import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

@Directive({
  selector: '[dateValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DateValidatorDirective, multi: true }],
  standalone: false
})
export class DateValidatorDirective implements Validator {
  @Input('dateValidator') dateValidator = '';

  dateValidatorFn(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valid = nameRe.test(control.value);
      return !valid ? { dateInvalid: { value: control.value } } : null;
    };
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.dateValidator ? this.dateValidatorFn(new RegExp(this.dateValidator, 'i'))(control)
      : null;
  }
}
